<template>
  <div v-if="isNavigating" class="fixed inset-0 bg-black bg-opacity-100 z-9999 flex items-center justify-center w-screen h-screen left-0 top-0">
    <div class="flex flex-col items-center gap-4">
      <div class="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent"></div>
      <p class="text-gray-300 text-sm">در حال بارگذاری...</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  isNavigating: boolean
}>()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
